// eslint-disable-next-line import/prefer-default-export
import Bookmark from './Bookmark';

export default Bookmark;
